import { StateStorage } from 'zustand/middleware';

const createResilientStorage = (storage: Storage = window.localStorage): StateStorage => ({
  getItem: (key) => {
    try {
      return storage.getItem(key);
    } catch {
      return null;
    }
  },
  setItem: (key, value) => {
    try {
      storage.setItem(key, value);
    } catch (error) {
      if (error instanceof Error && error.name === 'QuotaExceededError') {
        // Clear storage and try again
        storage.clear();
        try {
          storage.setItem(key, value);
        } catch {
          console.warn('Storage still failed after clearing');
        }
      }
    }
  },
  removeItem: (key) => {
    try {
      storage.removeItem(key);
    } catch {
      // Ignore remove errors
    }
  },
});

export { createResilientStorage };
